import React from "react";
import { TablePagination } from "@mui/material";
import BeatTargetRow from "./BeatTargetRow";
import { MONTH_COLUMNS, ROWS_PER_PAGE_OPTIONS } from "../constants/stockHolderTargetConstants";
import tableStyles from "../styles/tableStyles";

/**
 * BeatTargetTable
 *
 * Pure presentational component — owns NO state.
 * Renders the native <table> (for performance) and MUI TablePagination.
 *
 * Props:
 *  - pagedData              {Array}    Sliced rows for the current page
 *  - filteredCount          {number}   Total rows after search filter (for pagination count)
 *  - page                   {number}   Current 0-indexed page
 *  - rowsPerPage            {number}   Rows shown per page
 *  - onPageChange           {Function} (event, newPage) => void
 *  - onRowsPerPageChange    {Function} (event) => void
 *  - onTextFieldDataChange  {Function} Curried: (monthName, beatId) => (event) => void
 */
const BeatTargetTable = ({
    pagedData,
    filteredCount,
    page,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
    onTextFieldDataChange,
}) => (
    <>
        {/* ── Scrollable native table (zero MUI overhead per cell) ── */}
        <div style={{ overflowX: "auto", width: "100%" }}>
            <table style={tableStyles.table}>
                <thead>
                    <tr>
                        <th style={{ ...tableStyles.th, minWidth: 30 }}>Sr.No.</th>
                        <th style={{ ...tableStyles.th, minWidth: 90 }}>Region</th>
                        <th style={tableStyles.th}>State</th>
                        <th style={tableStyles.th}>Zone</th>
                        <th style={{ ...tableStyles.th, minWidth: 140 }}>Area</th>
                        <th style={{ ...tableStyles.th, minWidth: 160 }}>Beat</th>

                        {MONTH_COLUMNS.map(({ title, name }) => (
                            <th key={name} style={tableStyles.th}>
                                {title}
                            </th>
                        ))}

                        <th style={{ ...tableStyles.th, minWidth: 30 }}>Total Target</th>
                    </tr>
                </thead>

                <tbody>
                    {pagedData.map((row) => (
                        <BeatTargetRow
                            key={row.id}
                            row={row}
                            onTextFieldDataChange={onTextFieldDataChange}
                        />
                    ))}
                </tbody>
            </table>
        </div>

        {/* ── Pagination ── */}
        <TablePagination
            component="div"
            count={filteredCount}
            page={page}
            onPageChange={onPageChange}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={onRowsPerPageChange}
            rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
            labelRowsPerPage="Rows per page:"
        />
    </>
);

export default BeatTargetTable;
